module.exports = __webpack_public_path__ + "f20ac12b8b781cef148f365b25f9c77e.gif";